/**
 * keepWatchingCard.tsx
 */
import Card from '@shared/types/props/card';
import Colors from '@shared/assets/style/default/color';
import HorizontalCard from './horizontalCard';
import KeepWatching from '@shared/classes/keepWatching';
import RegularEvent from '@shared/classes/regularEvent';
import { keepWatchingSelector } from '@shared/store/slices/keepWatching.slice';
import { memo, useMemo } from 'react';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Keep watching card component.
 */
function KeepWatchingCard(props: Card) {
  const item = props.item as RegularEvent;
  const { data } = useAppSelector(keepWatchingSelector);

  const progressBar = useMemo(() => {
    const mark =
      data.find(
        (keepWatching: KeepWatching) => keepWatching.id === item.eventId
      )?.mark ??
      item.keepWatchingMark ??
      0;
    const duration =
      item?.endBookmark || (item?.duration ? item.duration * 60 : 0);
    const percentage = Math.max(
      mark && duration ? (mark / duration) * 100 : 0,
      0
    );
    return { color: Colors.progress.fillFastEvent, percentage };
  }, [item, data]);

  return <HorizontalCard {...props} progressBar={progressBar} />;
}

export default memo(KeepWatchingCard);
